export const sigsRequest = {
  scopes: ['https://substrate.office.com/search/.default'],
};
